import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostSalesSupply from "./supply";
import { locationPinCode, shipTolocationPinCode } from "services/redux/sales/corporate/locations/action";
import {postSalesSupplyLead, getContractRevenue, getContractService} from "services/redux/sales/postSales/action";
import { postSupply } from "services/redux/sales/postSales/supply/action";
import { clientBillingAddress } from "services/redux/sales/corporate/client/action";
import { supplyNameFun } from "services/redux/sales/corporate/categoryDetails/action";

import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { getMateriaById,getBrandById } from "services/redux/sales/postSales/corporate/action";

const mapStateToProps = (state) => ({
  pincodeData: state.locationReducer.pincodeData,
  postSupplyData: state.supplyPostLeadReducer.postSupplyData,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.coporatePostLeadReducer.getBrand,
  splNameData: state.categoryDetlReducer.splNameData,
  shipToPincodeData:  state.locationReducer.shipToPincodeData,
  clientBillingPocData: state.clientReducer.billingAddressPoc,
  contractRevenueDetails: state.postSalesReducer.contractRevenueDetails,
  contractCatService: state.postSalesReducer.contractCatService,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postSupply,
      locationPinCode,
      postSalesSupplyLead,
      documentUploadUrl,
      getMateriaById,
      getBrandById,
      imageUploadUrl,
      videoUploadUrl,
      supplyNameFun,
      shipTolocationPinCode,
      clientBillingAddress,
      getContractRevenue,
      getContractService
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostSalesSupply);
